/**
* Service Toggle JS
* -----------------------------------------------------------------------------
*
* All the JS for the Service Toggle component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'service-toggle',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.services-toggle__tab-btn' ).on( 'click', function( event ) {
        updateSelect( $( this ) );
      } );

      const forceToggle = ( ) => {
        $( '.services-toggle__select-btn.is-open' ).trigger( 'click' );
      };

      const updateSelect = ( selected ) => {
        $( '.services-toggle__select-text' ).text( $( selected ).text() );
        if ( window.matchMedia( '(max-width: 639px)' ).matches ) {
          forceToggle();
        }
      };

      $( '.services-toggle__select-btn' ).on( 'toggleAfter', ( event ) => {
        if ( window.matchMedia( '(max-width: 639px)' ).matches ) {
          $( event.target ).next().slideToggle( {
            start: function() {
              $( this ).css( 'display', 'flex' );
            },
          } );
        }
      } );


      function handleMobileChange( event ) {
        if ( event.matches ) {
          if ( $( '.service-toggle__select-btn' ).hasClass( 'is-open' ) ) {
            forceToggle();
          }
          $( '.service-toggle__dropdown' ).get( 0 ).style.removeProperty( 'display' );
        }
      }

      /* Run the handleMobileChange function when the screen sizes changes based on the mobileSize const */
      const mobileSize = window.matchMedia( '(min-width: 1024px)' );
      mobileSize.addEventListener( 'change', handleMobileChange );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'service-toggle', COMPONENT );
} )( app );
